import { EMPTY, Observable } from 'rxjs';
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { Loader, UnsubscriberClass, SortedFilteredList } from '@aston/foundation';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

import { ImportReportErrorColumnsListSortProp } from '../../enums';
import { IImportItem, IImportErrorColumnRowModel, IImportReportActions, IImportReportSelectors } from '../../models';
import { ImportReportErrorsListTableComponent } from '../import-report-errors-list-table/import-report-errors-list-table.component';
import * as AppStoreActions from '../../../root-store/app-store/actions';

type ReportErrorColumnsSortedList = SortedFilteredList<IImportErrorColumnRowModel, ImportReportErrorColumnsListSortProp>;

const defaultActions: IImportReportActions = {
	UpdateColumnsSettings: AppStoreActions.Noop(),
	ToggleLine: AppStoreActions.Noop(),
	LoadLinesRequest: AppStoreActions.Noop(),
	UpdateLinesSettings: AppStoreActions.Noop(),
}

const defaultSelectors: IImportReportSelectors = {
	selectErrorColumnsListIsLoading: EMPTY,
	selectErrorColumnsListError: EMPTY,
	selectLinesListIsLoading: () => EMPTY,
	selectLinesListError: () => EMPTY,
	selectLinesList: () => EMPTY,
	selectLinesListState: () => EMPTY,
}


@Component({
	selector: 'import-synthesis-report',
	templateUrl: './import-synthesis-report.component.html',
	imports: [
		AsyncPipe,
		TranslateModule,
		ImportReportErrorsListTableComponent,
	]
})
export class ImportSynthesisReportComponent extends UnsubscriberClass {
	@Input() currentImport: IImportItem;
	@Input() currentImportLoader = Loader.empty();
	@Input() list$: Observable<ReportErrorColumnsSortedList>;
	@Input() listLoader = Loader.empty();
	@Input() showDismiss = false;
	@Input() actions: IImportReportActions = defaultActions;
	@Input() selectors: IImportReportSelectors = defaultSelectors;

	@Output() dismiss = new EventEmitter<void>();
	@Output() download = new EventEmitter<void>();
}
